import { useIntl } from 'react-intl'
import CaptionTextBlock from '../TextBlocks/CaptionTextBlock'
import FormatCurrency from 'components/Common/FormatCurrency'
import Caption from '../Typography/Caption'
import LinePlaneDepartureIcon from '../Icons/line/LinePlaneDepartureIcon'

interface Props extends Utils.PropsWithDataAttributes {
  product: 'hotel' | 'tour'
  price: number | undefined
  /**
   * Appends the price with "/person"
   *
   * Wouldn't have any effect if `price` is not provided.
   */
  pricePerPerson?: boolean
}

function PriceRowFlightPackage(props: Props) {
  const {
    product,
    price,
    pricePerPerson,
    ...rest
  } = props

  const intl = useIntl()

  const formattedPrice = price !== undefined ? (
    <Caption
      as="span"
      variant="medium"
      colour="normal-contrast"
      weight="bold"
    >
      <FormatCurrency value={price} format="roundedDollar" />
    </Caption>
  ) : undefined

  const flightsFromPricePerPersonLabel = product === 'hotel'
    ? intl.formatMessage(
        {
          id: 'StE9OELih7uDVnK4mB-G',
          defaultMessage: 'Hotel + flights from {price}* /person',
          description: 'Flight package per person price label for hotel with flights',
        },
        { price: formattedPrice },
      )
    : intl.formatMessage(
        {
          id: 'pG2grQiTRjbX-chFvY8c',
          defaultMessage: 'Tour + flights from {price}* /person',
          description: 'Flight package per person price label for tour with flights',
        },
        { price: formattedPrice },
      )
  const flightsFromPriceLabel = product === 'hotel'
    ? intl.formatMessage(
        {
          id: 'me8Vzh2jbfUmzP2fBucY',
          defaultMessage: 'Hotel + flights from {price}*',
          description: 'Flight package total price label for hotel with flights',
        },
        { price: formattedPrice },
      )
    : intl.formatMessage(
        {
          id: 'Cbwt6mMvHPRaNoU-pPiX',
          defaultMessage: 'Tour + flights from {price}*',
          description: 'Flight package total price label for tour with flights',
        },
        { price: formattedPrice },
      )
  const flightsPackageAvailableLabel = product === 'hotel'
    ? intl.formatMessage({
        id: 'FjG4NqU8_Sy6u90U-_91',
        defaultMessage: 'Hotel + flights package available',
        description: 'Flight package availability label for hotel with flights',
      })
    : intl.formatMessage({
        id: 'ceAOGqZynSCAbrtfP6ux',
        defaultMessage: 'Tour + flights package available',
        description: 'Flight package availability label for tour with flights',
      })

  return <CaptionTextBlock
    {...rest}
    variant="medium"
    colour="light-foreground-alt"
    weight="normal"
    wrap="pre-wrap"
    startIcon={<LinePlaneDepartureIcon />}
  >
    {!!price && pricePerPerson && flightsFromPricePerPersonLabel}
    {!!price && !pricePerPerson && flightsFromPriceLabel}
    {price === undefined && flightsPackageAvailableLabel}
  </CaptionTextBlock>
}

export default PriceRowFlightPackage
